"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldOutputJson = void 0;
// Adding an option to bypass the AWS_EXECUTION_ENV check for local testing
const shouldOutputJson = () => process.env.AWS_EXECUTION_ENV === "AWS_ECS_FARGATE" || process.env.DAYTRIP_FORCE_LOG_JSON !== undefined;
exports.shouldOutputJson = shouldOutputJson;
//# sourceMappingURL=should-output-json.js.map